import type { Tenant, TenantBranding } from '@lensora/shared'
import { useMutation, useQueryClient } from '@tanstack/react-query'


import { api } from '@/lib/api'

export function useBrandingMutation() {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: (branding: Partial<TenantBranding>) =>
      api.patch<Tenant>('/api/admin/tenants/branding', branding),
    onSuccess: () => {
      // Invalidate both the me query and the tenant config query (used by
      // TenantProvider to apply CSS vars) so saved branding takes effect
      // immediately instead of requiring a page reload.
      queryClient.invalidateQueries({ queryKey: ['me'] })
      queryClient.invalidateQueries({ queryKey: ['tenant-config'] })
    },
  })
}

export function useLogoUploadMutation() {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: (file: File) => {
      const formData = new FormData()
      formData.append('file', file)
      return api.postForm<Tenant>('/api/admin/tenants/logo', formData)
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['me'] })
      queryClient.invalidateQueries({ queryKey: ['tenant-config'] })
    },
  })
}

export function useFeatureFlagMutation() {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: (flags: Record<string, boolean>) =>
      api.patch<Tenant>('/api/admin/tenants/feature-flags', flags),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['me'] })
      queryClient.invalidateQueries({ queryKey: ['tenant-config'] })
    },
  })
}

export function useCustomDomainMutation() {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: (customDomain: string | null) =>
      api.patch<Tenant>('/api/admin/tenants/custom-domain', { customDomain }),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['me'] })
    },
  })
}
